module.exports = __webpack_public_path__ + "static/opengraph-img.6b4eabc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/opengraph-img.png
// module id = 1771
// module chunks = 114276838955818